<template>
  <el-cascader style="width:100%;" :options="options" :show-all-levels="showalllevels" v-model="values"
    :filterable="filterable" @change="handleChange"
    :props="{
      expandTrigger: 'hover',
      checkStrictly: checkStrictly,
      children: 'childData',
      label: 'dictName',
      value: 'dictId'
    }"
    @blur="handleblur" @visible-change="visibleChange" clearable :disabled="editType=='examine'||editType=='info'||editType=='return'" :placeholder="'请选择'+placeholderLoad"></el-cascader>
</template>

<script>
export default {
  props: {
    editType: String, //修改类型 info：查看 add：新增 edit：编辑 examine：审批 return：回访
    expandtrigger: {
      type: String,
      default: "hover"
    },
    bindata: {
      type: Array,
      default() {
        return [];
      }
    },
    showalllevels: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: true
    },
    defaultoptions: {
      type: String,
      default: "",
    },
    // changeonselect: {
    //   type: Boolean,
    //   default: true
    // },
    placeholderLoad:{
      type: String,
      default: "",
    },
    checkStrictly:{
      type: Boolean,
      default: false  
    }
  },
  data() {
    return {
      options: [],
      values: [],
      selectval: ""
    };
  },
  methods: {
    handleChange(value) {
      if (value.length > 0) {
        // this.selectval = value[value.length - 1]
        this.selectval = value
        this.$emit("setvalue", this.selectval)
      }
      if(value.length == 0){
        this.selectval =""
        this.$emit("setvalue", this.selectval)
      }
      
    },
    handleblur() {
      this.$emit("setvalue", this.selectval)
    },
    clearData(){
      this.values =[]
      this.selectval = ""
      this.$emit("setvalue", this.selectval)
    },
    visibleChange(funcStatus){
      if(!funcStatus){
        this.$emit("setvalue", this.selectval)
      }
    }
  },
  watch: {
    bindata: function(newVal) {
      this.options = newVal
    },
    defaultoptions: {
      immediate: true,
      deep:true,
      handler(newV,oldV) {
        if(this.showalllevels && newV !=""){
          let newSetvalue = newV.split(",").slice(-1)
          this.values = newSetvalue.join(',')
        }
        this.$emit("setvalue", newV)
        },
      },
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// Cascader.vue?f9909be2